export default __webpack_public_path__ + "static/media/hex_more_mix.cb7f762f.svg";